import React, {Component} from 'react'
import Icon from "../../../common/icon/icon.component.jsx"
import {FormattedMessage, FormattedHTMLMessage} from "react-intl";

class PricingStrategySelector extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function(){},
            strategy: this.props.value || ''
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            strategy: nextProps.value
        })
    }

    getStrategies() {
        return [
            {
                id: 'multiplier',
                icon: <Icon value={"circle"} />,
                name: <FormattedMessage
                    id="product.pricing_strategy.multiplier.name"
                    defaultMessage="Standard"
                />,
                description: <FormattedMessage
                    id="product.pricing_strategy.multiplier.description"
                    defaultMessage="This is a simple calculation using a multiplication"
                />,
                textFormula: <FormattedMessage
                    id="product.pricing_strategy.multiplier.text_formula"
                    defaultMessage="[quantity] x [unit price] = [total price]"
                />,
                numberFormula: "30 x $10 = $300",
            },
            {
                id: 'bracket',
                icon: <Icon value={"boxes"} />,
                name: <FormattedMessage
                    id="product.pricing_strategy.bracket.name"
                    defaultMessage="Box pricing"
                />,
                description: <FormattedMessage
                    id="product.pricing_strategy.bracket.description"
                    defaultMessage="This strategy allows you to price by box price even when you sell part of a box"
                />,
                textFormula: <FormattedMessage
                    id="product.pricing_strategy.bracket.text_formula"
                    defaultMessage="[quantity] / [box size] x [box unit price] = [total price]"
                />,
                numberFormula: "30 / 6 x $10 = $50",
            },
            {
                id: 'bracket-custom',
                icon: <Icon value={"pencil-ruler"} />,
                name: <FormattedMessage
                    id="product.pricing_strategy.custom_bracket.name"
                    defaultMessage="Custom bracket"
                />,
                description: <FormattedMessage
                    id="product.pricing_strategy.custom_bracket.description"
                    defaultMessage="This strategy allows you to define freely the price based on the quantity"
                />,
                textFormula: <FormattedMessage
                    id="product.pricing_strategy.custom_bracket.text_formula"
                    defaultMessage="if [quantity] >= [bracket from] and [quantity] <= [bracket to] then [total price] = [bracket price]"
                />,
                numberFormula: <FormattedHTMLMessage
                    id="product.pricing_strategy.custom_bracket.number_formula"
                    defaultMessage="One bracket start from 1 to 10 and the price is $100.<br />
                    A second bracket start from 11 to 20 and the price is $200.<br />
                    if the quantity is 5, the total price is $100<br />
                    if the quantity is 15, the total price is $200<br />
                    if the quantity is 10, the total price is $100
                    "
                />,
            },
            {
                id: 'bulk',
                icon: <Icon value={"pallet"} />,
                name: <FormattedMessage
                    id="product.pricing_strategy.bulk.name"
                    defaultMessage="Bulk pricing"
                />,
                description: <FormattedMessage
                    id="product.pricing_strategy.bulk.description"
                    defaultMessage="This strategy allows you to define the unit price based on the quantity"
                />,
                textFormula: <FormattedMessage
                    id="product.pricing_strategy.bulk.text_formula"
                    defaultMessage="if [quantity] >= [bracket from] and [quantity] <= [bracket to] then [bracket unit price] x [quantity] = [bracket price]"
                />,
                numberFormula: <FormattedHTMLMessage
                    id="product.pricing_strategy.bulk.number_formula"
                    defaultMessage="One bracket start from 1 to 10 and the unit price is $10.<br />
                    A second bracket start from 11 to 20 and the  unit price is $7.<br />
                    if the quantity is 5, the total price is $50<br />
                    if the quantity is 15, the total price is $105<br />
                    if the quantity is 10, the total price is $100
                    "
                />,
            },
            {
                id: 'custom-formula',
                icon: <Icon value={"code"} />,
                name: <FormattedMessage
                    id="product.pricing_strategy.custom_formula.name"
                    defaultMessage="Custom formula"
                />,
                description: <FormattedMessage
                    id="product.pricing_strategy.custom_formula.description"
                    defaultMessage="This strategy allows you to define an advanced formula to calculate price and cost"
                />,
                textFormula: '',
                numberFormula: '',
            },
        ]
    }

    selectStrategy(id) {
        return function (e) {
            e.preventDefault()
            this.setState({
                strategy: id,
            }, () => {
                this.state.onChange(id)
            })
        }.bind(this)
    }

    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="d-flex align-content-stretch flex-wrap">
                        {this.getStrategies().map(c => {
                            let className = "card h-100"
                            if (this.state.strategy === c.id) {
                                className += " bg-primary text-white"
                            }
                            return <div key={c.id} className="col-xl-2 col-lg-3 align-self-stretch p-1 no-underline">
                                <a key={c.id} href='#' onClick={this.selectStrategy(c.id)}>
                                    <div className={className}>
                                        <div className="card-body px-1">
                                            <h5 className="card-title m-0 p-0 border-0">
                                                <p className="text-center m-0">
                                                    {c.icon}
                                                </p>
                                            </h5>
                                            <h6 className="card-title m-0 p-0 border-0">
                                                <p className="text-center m-0 pt-1">
                                                    {c.name}
                                                </p>
                                            </h6>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        })}
                    </div>
                </div>
                <div className="col-12">
                    {this.getStrategies().map(c => {
                        let className = ""
                        if (this.state.strategy === c.id) {
                            className += " show bg-light col-md-8 col-sm-12 p-1 mt-1 rounded"
                        } else {
                            className += " d-none"
                        }
                        return <div key={c.id} className={className} id={"list-" + c.id } role="tabpanel"
                                    aria-labelledby={"list-" + c.id + "-list"}>
                            <p className="p-2 m-0" >
                                <small>
                                    <Icon value={"info"}/>
                                    {c.description}<br />
                                    {c.textFormula ? <strong><u>
                                        <FormattedMessage
                                            id="product.pricing_strategy.formula_label"
                                            defaultMessage="Formula:"
                                        />
                                    </u><br /></strong>:''}
                                    <em>{c.textFormula}</em><br />
                                    {c.numberFormula ? <strong><u><FormattedMessage
                                        id="product.pricing_strategy.example_label"
                                        defaultMessage="Example:"
                                    /></u><br /></strong>:''}
                                    {c.numberFormula}
                                </small>
                            </p>
                        </div>
                    })}
                </div>
            </div>
        );
    }
}

export default PricingStrategySelector


// WEBPACK FOOTER //
// ./src/product/form/pricing-strategy/select.component.jsx